<template>
  <hm-content title="促销列表">
    <div class="table-panel flex flex-end">
      <el-date-picker
        v-model="date"
        type="daterange"
        align="right"
        start-placeholder="促销开始时间"
        end-placeholder="促销结束时间"
        value-format="yyyy-MM-dd"
        size="small"
        class="mr10"
      ></el-date-picker>
      <el-select
        clearable
        v-model="promotionCode"
        placeholder="促销类型"
        size="small"
        filterable
        class="mr10"
      >
        <el-option
          v-for="item in activityChildCategoryList"
          :key="item.promotionCode"
          :label="item.typeName"
          :value="item.promotionCode"
        ></el-option>
      </el-select>
      <el-select
        clearable
        v-model="timeStatus"
        placeholder="时间状态"
        size="small"
        filterable
        class="mr10"
      >
        <el-option label="未开始" value="notStarted"></el-option>
        <el-option label="进行中" value="running"></el-option>
        <el-option label="已结束" value="end"></el-option>
      </el-select>
      <el-select
        clearable
        v-model="enabledState"
        placeholder="促销状态"
        size="small"
        filterable
        class="mr10"
      >
        <el-option label="上线" value="enable"></el-option>
        <el-option label="下线" value="disabled"></el-option>
      </el-select>
      <el-input
        clearable
        v-model.trim="promotionName"
        placeholder="输入促销名称"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button
        type="success"
        size="small"
        @click="output"
        :loading="isOutputing"
        >导出</el-button
      >
    </div>
    <div class="table">
      <div class="hm-radio-group">
        <el-radio-group v-model="auditState" size="small" @change="switchTab">
          <el-radio-button label="wait_audit"
            >待审核({{
              checkActivityRecordListCount.waitAudit
            }})</el-radio-button
          >
          <!-- <el-radio-button label="in_audit">审核中({{checkActivityRecordListCount.inAudit}})</el-radio-button> -->
          <el-radio-button label="audit_pass"
            >审核通过({{
              checkActivityRecordListCount.auditPass
            }})</el-radio-button
          >
          <el-radio-button label="reject"
            >驳回({{ checkActivityRecordListCount.reject }})</el-radio-button
          >
        </el-radio-group>
      </div>
      <el-table
        stripe
        border
        :data="checkActivityRecordList.records"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="促销类型">
          <template slot-scope="scope">
            <div class="table-status flex item-center">
              <span
                class="status success-bg"
                v-show="scope.row.timeStatus === 'running'"
              ></span>
              <span
                class="status gray-bg"
                v-show="scope.row.timeStatus === 'notStarted'"
              ></span>
              <span
                class="status danger-bg"
                v-show="scope.row.timeStatus === 'end'"
              ></span>
              <span class="flex flex-1 flex-start">{{
                scope.row.typeName
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="promotionName"
          label="促销名称"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              :content="scope.row.promotionName"
              placement="top"
            >
              <div class="flex item-center">
                <span class="pos" v-if="scope.row.createMode">
                  p
                </span>
                <span class="time flex-1 text-overflow">
                  {{ scope.row.promotionName }}
                </span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="reason"
          show-overflow-tooltip
          label="驳回原因"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="300px"
          prop="startDateFormat"
          label="促销时间"
        >
          <template slot-scope="scope">
            <span class="time">
              {{ scope.row.startDate }}至{{ scope.row.endDate }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="serverGuider"
          label="参与门店"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              :content="scope.row.outLet.join(',')"
              placement="top"
            >
              <div class="text-overflow">
                <span v-for="(v, i) in scope.row.outLet" :key="i">
                  {{ v }}
                </span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="introText"
          label="促销备注"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              :content="scope.row.introText"
              placement="top"
            >
              <span class="text-overflow">
                {{ scope.row.introText }}
              </span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="statusFormat"
          label="促销标签"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              :content="scope.row.labels.join(',')"
              placement="top"
            >
              <div class="text-overflow">
                <span v-for="(v, i) in scope.row.labels" :key="i">
                  {{ v }}
                </span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="审核状态">
          <template slot-scope="scope">
            <span
              class="status blue"
              v-show="scope.row.auditState === 'wait_commit'"
              >待提交</span
            >
            <span
              class="status blue"
              v-show="scope.row.auditState === 'wait_audit'"
              >待审核</span
            >
            <span
              class="status blue"
              :class="scope.row.auditState"
              v-show="scope.row.auditState === 'in_audit'"
              >审核中</span
            >
            <span
              class="status success"
              :class="scope.row.auditState"
              v-show="scope.row.auditState === 'audit_pass'"
              >审核通过</span
            >
            <span
              class="status danger"
              :class="scope.row.auditState"
              v-show="scope.row.auditState === 'reject'"
              >已驳回</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="enabledState"
          label="促销状态"
        >
          <template slot-scope="scope">
            <span
              class="status danger"
              v-show="scope.row.enabledState === 'disabled'"
              >下线</span
            >
            <span
              class="status success"
              v-show="scope.row.enabledState === 'enable'"
              >上线</span
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="查看" placement="top">
                <div class="pointer" @click="toDetails(scope.row)">
                  <span class="hmicon icon-chakan blue"></span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <hm-status />
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="checkActivityRecordList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        :page-size="pageSize"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
import HmStatus from "@/components/HmStatus";
import moment from "moment";
import { mapGetters } from "vuex";
import { setCookie, getCookie } from "../../utils/utils";
export default {
  components: { HmStatus },
  data() {
    return {
      activityChildCategoryList: [],
      currentPage: 1,
      startDate: "",
      endDate: "",
      timeStatus: "",
      pageSize: 10,
      date: [],
      promotionCode: "",
      promotionName: "",
      enabledState: "",
      auditState: "wait_audit",
      isOutputing: false
    };
  },
  created() {
    this.getParamsCookie();
    const echoParams =
      getCookie({ key: "ACTIVITYCHECKlIST", type: "session" }) || {};
    for (let key in echoParams) {
      if (this.hasOwnProperty(key)) {
        this[key] = echoParams[key];
      }
    }
    if (echoParams.startDate && echoParams.endDate) {
      this.date = [
        new Date(echoParams.startDate),
        new Date(echoParams.endDate)
      ];
    }
    this.currentPage = echoParams.pageNo || 1;
  },
  mounted() {
    this.queryList();
    this.$store.dispatch("queryActivityCategoryList");
  },
  computed: mapGetters([
    "checkActivityRecordList",
    "checkActivityRecordListCount",
    "allCheckActivityRecordList",
    "activityCategoryList",
    "activeListCount"
  ]),
  watch: {
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach(v => {
        this.activityChildCategoryList = this.activityChildCategoryList.concat(
          v.nodes
        );
      });
    },
    dateAndTime(val) {
      this.startDate = val ? moment(val[0]).format("YYYY-MM-DD HH:mm:ss") : "";
      this.endDate = val ? moment(val[1]).format("YYYY-MM-DD HH:mm:ss") : "";
    }
  },
  methods: {
    toDetails(row) {
      this.$router.push({
        name: "ActivityDetails",
        query: {
          id: row.id,
          type: row.auditState,
          parentId: row.promotionCode.split("-")[0]
        }
      });
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        const {
          exportJsonToExcel
        } = require("../../utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(() => {
            const list = this.allCheckActivityRecordList;
            const tHeader = [
              "促销类型",
              "促销名称",
              "促销时间",
              "参与门店",
              "促销备注",
              "促销标签",
              "审核状态",
              "促销状态"
            ];
            const filterVal = [
              "typeName",
              "promotionName",
              "activityDateTime",
              "outLet",
              "introText",
              "labelsFormat",
              "auditStateFormat",
              "enabledStateFormat"
            ];
            const data = this.formatJson(filterVal, list);

            exportJsonToExcel(tHeader, data, "促销活动列表");
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    switchAuditState(id, enabledState) {
      this.$store
        .dispatch("switchAuditState", {
          enabledState,
          id
        })
        .then(() => {
          this.queryList();
        });
    },
    remove(row) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("deleteCurrentRowActivity", {
            id: row.id
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.queryList();
            }
          });
      });
    },
    addActivity() {
      this.$router.push({
        name: "SelectActivity"
      });
    },
    switchTab() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    queryList() {
      this.setParamsCookie();
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        startDate: this.date ? this.date[0] : null,
        endDate: this.date ? this.date[1] : null,
        promotionCode: this.promotionCode,
        auditState: this.auditState,
        enabledState: this.enabledState,
        promotionName: this.promotionName,
        timeStatus: this.timeStatus
      };
      setCookie({
        key: "ACTIVITYCHECKlIST",
        type: "session",
        data: params
      });
      return this.$store.dispatch("queryCheckActivityRecordList", params);
    },
    setParamsCookie() {
      let searchCondition = {
        date: this.date,
        promotionCode: this.promotionCode,
        auditState: this.auditState,
        enabledState: this.enabledState,
        promotionName: this.promotionName,
        timeStatus: this.timeStatus
      };
      setCookie({
        key: "activityCheckRecordParams",
        type: "session",
        data: Object.assign({}, searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({
        key: "activityCheckRecordParams",
        type: "session"
      });
      if (prams) {
        this.date = prams.date;
        this.promotionCode = prams.promotionCode;
        this.auditState = prams.auditState;
        this.enabledState = prams.enabledState;
        this.promotionName = prams.promotionName;
        this.timeStatus = prams.timeStatus;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    queryAllList() {
      return this.$store.dispatch("queryAllCheckActivityRecordList", {
        pageSize: 999999,
        pageNo: this.currentPage,
        startDate: this.date ? this.date[0] : null,
        endDate: this.date ? this.date[1] : null,
        promotionCode: this.promotionCode,
        auditState: this.auditState,
        enabledState: this.enabledState,
        promotionName: this.promotionName,
        timeStatus: this.timeStatus
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss">
.btn.active {
  background: #71abff;
  color: #fff;
  border-radius: 5px;
}
.btn-group {
  margin-bottom: 2rem;
}

.status {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 10px;
  margin-top: -2px;
}

.pos {
  margin-right: 5px;
  width: 15px;
  height: 15px;
  line-height: 15px;
  background: #e50163;
  color: #fff;
}
</style>
